<template>
    <div id="lyrics" class="container">
    	<div class="row">
    		<div class="col-xs-12 text">
    			<p v-html="text"></p>
    		</div>
    	</div>
	</div>
</template>

<style type="text/css">
	#lyrics{ min-height: 0px; padding: 30px; text-align: center; min-height: 60vh; }

	#lyrics .text{ margin: 0px 0px 50px 0px; font-size: 14px; text-align: center;}
	#lyrics .text strong{ font-weight: 900; }

	#lyrics h5{ line-height: 45px; }
	#lyrics .row > div { padding: 0px 10px; }
</style> 

<script>
export default {
    components: {
        'loader': require('@/components/Loader.vue').default,
    },

    props: ['song'],

    data() {
        return {
        	text: this.song.lyrics ? this.song.lyrics : "Currently No Lyrics",
		}
	},

	computed: {
		isOwner(){
			return App.user.id == this.song.uploader_id;
		}
	}
}
</script>
